import {Checkbox, Popover, Row, Col} from 'antd';

export const InventoryHideWidget = ({hidden, onHide, props}) => {
    const checkText = hidden ? 'Hidden' : 'Visible';

    const onClick = () => {
        if (onHide) {
            onHide();
        }
    }

    return <Popover content={`Hide unused inventory from inventory list`}>
        <Row>
            <Col style={{marginTop: '5px', marginBottom: "5px", marginRight: '5px'}}>
                <Checkbox checked={hidden} onChange={onClick}></Checkbox>
            </Col>
            <Col style={{margin: '5px'}}>
                {checkText}
            </Col>
        </Row>
    </Popover>
}